(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["un-featured-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const products = document.querySelectorAll('.cun-featured-product');
  
  products.forEach(product => {
    product.addEventListener('click', function() {
      const productUrl = this.getAttribute('data-product-url');
      if (productUrl) {
        window.location.href = productUrl;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
